import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=a3b5f260&scoped=true"
import script from "./PointList.vue?vue&type=script&lang=js"
export * from "./PointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b5f260",
  null
  
)

export default component.exports